import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ImageMap } from "@qiuz/react-image-map";
import { PieChart, Pie, Cell } from "recharts";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Badge from "react-bootstrap/esm/Badge";
import { CircularProgress } from "@mui/material";

const PerformanceImage = ({
  building,
  userInfo,
  loadPerformance,
  floor,
  rooms,
  ranking,
  selectedAllRooms,
  setSelectedRooms,
  setRoom,
  setRooms,
  setTooltipRoom,
  setTooltipPosition,
  showDetail,
  setShowDetail,
  setSelectedTime,
  selectedKPI,
  noOfPeople,
  noOfEmptySeat,
  spaceUtilization,
  occupancyUtilization,
  peakOccupancyUtilization,
  totalEntryByLocation,
  totalExitByLocation,
  date,
  selectedPattern,
}) => {
  const [temperatureArea, setTemperatureArea] = useState([]);
  // const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  // const [showDetail, setShowDetail] = useState(false);
  // const [selectedRoom, setSelectedRoom] = useState(null);
  const [mapArea, setMapArea] = useState([
    !floor
      ? []
      : floor.rooms.map((room) => {
          return {
            ...room,
            left: room.leftPin,
            top: room.topPin,
            style: { border: "", zIndex: 100 },
            selected: false,
          };
        }),
  ]);

  const [mapClick, setMapClick] = useState(null);

  const floorImage = useSelector(
    (state) => state.performanceDashboard.data?.floorImage
  );

  const dispatch = useDispatch();

  // Helper function to convert hex color to rgb
  const hexToRgb = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
  };

  // Function to generate lighter or darker shades based on percentage
  const calculateColorShade = (percentage) => {
    // const baseColor = "#112138";

    // // Adjust the saturation/darkness based on the percentage
    // const factor = percentage <= 30 ? 1 : percentage <= 50 ? 0.7 : 0.5; // Factor decreases as percentage increases

    // // Convert hex color to rgb
    // const rgb = hexToRgb(baseColor);

    // // Apply the factor to adjust the color intensity (darker or lighter)
    // // const adjustedColor = `rgb(${Math.floor(rgb.r * factor)}, ${Math.floor(
    // //   rgb.g * factor
    // // )}, ${Math.floor(rgb.b * factor)})`;
    // const adjustedColor = baseColor;

    // return adjustedColor;

    const baseColor = "rgba(17, 33, 56, 0.7)"; // #112138 with 0.7 opacity
    return baseColor;
  };

  const calculateBubbleSize = (peopleCount) => {
    const floorPlanImage = document.querySelector(".usage-map");
    if (!floorPlanImage) return { width: "30px", height: "30px" };

    // Get the actual displayed dimensions of the floor plan
    const imageWidth = floorPlanImage.clientWidth;
    const imageHeight = floorPlanImage.clientHeight;

    console.log("test floorPlanImage", imageWidth, imageHeight);

    // Calculate the base size as a percentage of the smaller dimension
    const baseDimension = Math.min(imageWidth, imageHeight);
    const baseSize = baseDimension * 0.05; // 5% of the smaller dimension as base size

    // Scale factor based on number of people
    let scaleFactor;
    if (peopleCount === 0) {
      scaleFactor = 0;
    } else if (peopleCount < 2) {
      scaleFactor = 1;
    } else if (peopleCount < 3) {
      scaleFactor = 1.5;
    } else {
      scaleFactor = 2;
    }

    const size = baseSize * scaleFactor;
    // Calculate font size as a proportion of bubble size
    const fontSize = Math.max(size * 0.4, 12); // 40% of bubble size, minimum 12px

    return {
      width: `${size}px`,
      height: `${size}px`,
      fontSize: `${fontSize}px`,
    };
  };

  const calculateBubblePosition = (leftPin) => {
    const leftPercentage = parseFloat(leftPin);
    const newLeftPosition = leftPercentage - 2;
    return newLeftPosition;
  };
  //Effect: Show the heatmap on floor plan based on selected pattern .
  useEffect(() => {
    if (floor) {
      let style = {};
      let styleKPI = {};
      let data = [];

      if (
        (Object.keys(spaceUtilization).length !== 0 &&
          temperatureArea.length === 0) ||
        selectedPattern !== null
      ) {
        // No Of People
        if (selectedKPI === 1) {
          for (const [key, value] of Object.entries(noOfPeople)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;

            // Old logic occupancy utilization

            // const percentage = (value.avg / value.count / 10) * 100;

            // // Define base color (light blue shade)
            // const adjustedColor = calculateColorShade(percentage);

            // if (percentage < 30) {
            //   styleKPI = {
            //     // background: `radial-gradient(circle, ${adjustedColor} 0%, rgba(201, 233, 244, 0) 70%)`,
            //     background: adjustedColor,
            //     cursor: "pointer",
            //     color: adjustedColor,
            //     borderRadius: "50%",
            //     zIndex: 0,
            //     width: "3em",
            //     height: "3em",
            //   };
            // } else if (percentage < 50) {
            //   styleKPI = {
            //     // background: `radial-gradient(circle, ${adjustedColor} 0%, rgba(201, 233, 244, 0) 70%)`,
            //     background: adjustedColor,
            //     cursor: "pointer",
            //     color: adjustedColor,
            //     borderRadius: "50%",
            //     zIndex: 0,
            //     width: "5em",
            //     height: "5em",
            //   };
            // } else {
            //   styleKPI = {
            //     // background: `radial-gradient(circle, ${adjustedColor} 0%, rgba(201, 233, 244, 0) 70%)`,
            //     background: adjustedColor,
            //     cursor: "pointer",
            //     color: adjustedColor,
            //     borderRadius: "50%",
            //     zIndex: 0,
            //     width: "6em",
            //     height: "6em",
            //   };
            // }

            // New logic No of People
            const totalNoOfPeople =
              Math.round(value.NoP_front / value.count) +
              Math.round(value.NoP_back / value.count) +
              Math.round(value.NoP_left / value.count) +
              Math.round(value.NoP_right / value.count);

            const oldNoOfPeople = Math.round(value.avg / value.count);

            const adjustedColor = calculateColorShade(totalNoOfPeople);

            if (oldNoOfPeople === 0) {
              styleKPI = {
                cursor: "pointer",
                color: adjustedColor,
              };
            } else {
              styleKPI = {
                position: "absolute",
                top: room.topPin,
                left: `${calculateBubblePosition(room.leftPin)}%`,
                background: adjustedColor,
                cursor: "pointer",
                color: adjustedColor,
                borderRadius: "50%",
                width: `${calculateBubbleSize(oldNoOfPeople).width}`,
                height: `${calculateBubbleSize(oldNoOfPeople).height}`,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
              // Render the text of the temperature area
              render: (area, index) => (
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                  <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                    {/* Camera Direction */}
                    <span>
                      {room.camera_Direction === "Front"
                        ? `⬆`
                        : room.camera_Direction === "Back"
                        ? `⬇`
                        : room.camera_Direction === "Left"
                        ? `⬅`
                        : room.camera_Direction === "Right"
                        ? `➡`
                        : null}
                    </span>

                    {/* <div
                      style={{
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                        WebkitTextStroke: "1px black",
                      }}
                    >
                      {room.Room}
                    </div> */}

                    {/* Total No of People */}
                    <div
                      style={{
                        fontSize: `${
                          calculateBubbleSize(oldNoOfPeople).fontSize
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        WebkitTextStroke: "1px white",
                      }}
                    >
                      {oldNoOfPeople}
                    </div>
                  </div>
                </div>
              ),
            });
          }
        }

        // No of Empty Seat
        if (selectedKPI === 2) {
          for (const [key, value] of Object.entries(noOfEmptySeat)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;

            // const percentage = (value.avg / value.count / value.max) * 100;

            // // Define base color (light blue shade)
            // const adjustedColor = calculateColorShade(percentage);

            // if (percentage < 30) {
            //   styleKPI = {
            //     background: `radial-gradient(circle, ${adjustedColor} 0%, rgba(201, 233, 244, 0) 70%)`,
            //     cursor: "pointer",
            //     color: adjustedColor,
            //     borderRadius: "50%",
            //     zIndex: 0,
            //   };
            // } else if (percentage < 50) {
            //   styleKPI = {
            //     background: `radial-gradient(circle, ${adjustedColor} 0%, rgba(201, 233, 244, 0) 70%)`,
            //     cursor: "pointer",
            //     color: adjustedColor,
            //     borderRadius: "50%",
            //     zIndex: 0,
            //   };
            // } else {
            //   styleKPI = {
            //     background: `radial-gradient(circle, ${adjustedColor} 0%, rgba(201, 233, 244, 0) 70%)`,
            //     cursor: "pointer",
            //     color: adjustedColor,
            //     borderRadius: "50%",

            //     zIndex: 0,
            //   };
            // }

            // data.push({
            //   ...room,
            //   left: room.leftPin,
            //   top: room.topPin,
            //   style: styleKPI,
            //   // Render the text of the temperature area
            //   render: (area, index) => (
            //     <div className="w-100 d-flex flex-column">
            //       <div className="w-100 d-flex">
            //         <span
            //           style={{
            //             fontSize: "16px",
            //             display: "flex",
            //             alignItems: "center",
            //             justifyContent: "center",
            //             color: "white",
            //             fontWeight: "bold",
            //             WebkitTextStroke: "1px black",
            //           }}
            //         >
            //           {/* {Math.ceil(value.avg / value.count)}{" "} */}
            //         </span>
            //       </div>
            //     </div>
            //   ),
            // });

            // New logic No of Empty Seat
            const totalEmptySeat =
              Math.round(value.NoES_front / value.count) +
              Math.round(value.NoES_back / value.count) +
              Math.round(value.NoES_left / value.count) +
              Math.round(value.NoES_right / value.count);

            const oldEmptySeat = Math.round(value.avg / value.count);

            const adjustedColor = calculateColorShade(totalEmptySeat);

            if (oldEmptySeat === 0) {
              styleKPI = {
                cursor: "pointer",
                color: adjustedColor,
              };
            } else {
              styleKPI = {
                position: "absolute",
                top: room.topPin,
                left: `${calculateBubblePosition(room.leftPin)}%`,
                background: adjustedColor,
                cursor: "pointer",
                color: adjustedColor,
                borderRadius: "50%",
                width: `${calculateBubbleSize(oldEmptySeat).width}`,
                height: `${calculateBubbleSize(oldEmptySeat).height}`,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
              // Render the text of the temperature area
              render: (area, index) => (
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                  <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                   {/* Camera Direction */}
                   <span>
                      {room.camera_Direction === "Front"
                        ? `⬆`
                        : room.camera_Direction === "Back"
                        ? `⬇`
                        : room.camera_Direction === "Left"
                        ? `⬅`
                        : room.camera_Direction === "Right"
                        ? `➡`
                        : null}
                    </span>

                    {/* <div
                      style={{
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                        WebkitTextStroke: "1px black",
                      }}
                    >
                      {room.Room}
                    </div> */}

                    {/* Total No of People */}
                    <div
                      style={{
                        fontSize: `${
                          calculateBubbleSize(oldEmptySeat).fontSize
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        WebkitTextStroke: "1px white",
                      }}
                    >
                      {oldEmptySeat}
                    </div>
                  </div>
                </div>
              ),
            });
          }
        }

        // Comfort Utilization heatmap
        if (selectedKPI === 3) {
          for (const [key, value] of Object.entries(spaceUtilization)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            if (value.avg / value.count < 30) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255,0,0,1), rgba(255,0,0,0) 70%)`,
                cursor: "pointer",
                color: `rgb(255,0,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (value.avg / value.count < 50) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255,255,0,1), rgba(255,255,0,0) 70%)`,
                cursor: "pointer",
                color: `rgb(255,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else {
              styleKPI = {
                background:
                  "radial-gradient(circle, rgba(0,255,0,1), rgba(0,255,0,0) 70%",
                cursor: "pointer",
                color: `rgb(0,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
              // Render the text of the temperature area
              render: (area, index) => (
                <span
                  style={
                    room.floors_id === 1
                      ? {
                          position: "absolute",
                          top: "30%",
                          left: "30%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          background: "white",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                      : {
                          position: "absolute",
                          top: "0%",
                          left: "0%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          fontSize: "50%",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                  }
                >
                  {value.avg / value.count > 100
                    ? 100
                    : (value.avg / value.count).toFixed(0)}
                  %
                </span>
              ),
            });
          }
        }

        // Space Utilization heatmap
        if (selectedKPI === 4) {
          for (const [key, value] of Object.entries(occupancyUtilization)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            if (value.avg / value.count < 20) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255,0,0,1), rgba(255,0,0,0) 70%)`,
                cursor: "pointer",
                color: `rgb(255,0,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (value.avg / value.count < 50) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255,255,0,1), rgba(255,255,0,0) 70%)`,
                cursor: "pointer",
                color: `rgb(255,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else {
              styleKPI = {
                background:
                  "radial-gradient(circle, rgba(0,255,0,1), rgba(0,255,0,0) 70%",
                cursor: "pointer",
                color: `rgb(0,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
              // Render the text of the temperature area
              render: (area, index) => (
                <span
                  style={
                    room.floors_id === 1
                      ? {
                          position: "absolute",
                          top: "30%",
                          left: "30%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          background: "white",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                      : {
                          position: "absolute",
                          top: "0%",
                          left: "0%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          fontSize: "50%",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                  }
                >
                  {value.avg / value.count > 100
                    ? 100
                    : (value.avg / value.count).toFixed(0)}
                  %
                </span>
              ),
            });
          }
        }

        // Peak Occupancy heatmap
        if (selectedKPI === 8) {
          for (const [key, value] of Object.entries(peakOccupancyUtilization)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            if (value.max < 30) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255,0,0,1), rgba(255,0,0,0) 70%)`,
                cursor: "pointer",
                color: `rgb(255,0,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (value.max < 50) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255,255,0,1), rgba(255,255,0,0) 70%)`,
                cursor: "pointer",
                color: `rgb(255,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else {
              styleKPI = {
                background:
                  "radial-gradient(circle, rgba(0,255,0,1), rgba(0,255,0,0) 70%",
                cursor: "pointer",
                color: `rgb(0,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
              // Render the text of the temperature area
              render: (area, index) => (
                <span
                  style={
                    room.floors_id === 1
                      ? {
                          position: "absolute",
                          top: "30%",
                          left: "30%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          background: "white",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                      : {
                          position: "absolute",
                          top: "0%",
                          left: "0%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          fontSize: "50%",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                  }
                >
                  {value.max.toFixed(0) > 100 ? 100 : value.max.toFixed(0)}%
                </span>
              ),
            });
          }
        }
        // Top 5
        if (selectedKPI === 9) {
          for (let i = 0; i < ranking.length; i++) {
            const room = floor.rooms.filter(
              (r) => r.Room.split(" - ")[0] === ranking[i]["Room"]
            )[0];
            if (!room) continue;
            if (i === 1) {
              styleKPI = {
                background: ``,
                cursor: "pointer",
                color: `rgb(255,0,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (i === 2) {
              styleKPI = {
                background: ``,
                cursor: "pointer",
                color: `rgb(255,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else {
              styleKPI = {
                background: "",
                cursor: "pointer",
                color: `rgb(0,255,0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
              // Render the text of the temperature area
              render: (area, index) => (
                <span
                  style={
                    room.floors_id === 1
                      ? {
                          position: "absolute",
                          top: "30%",
                          left: "30%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          background: "",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                      : {
                          position: "absolute",
                          top: "0%",
                          left: "0%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "black",
                          fontSize: "50%",
                          fontWeight: "bold",
                          padding: "2px",
                          borderRadius: "20%",
                        }
                  }
                >
                  {index + 1 === 1 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="30px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#FFD700"
                    >
                      <path
                        d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Zm-20 200h80v-400H380v80h80v320Z"
                        stroke="black"
                        stroke-width="20"
                      />
                    </svg>
                  ) : index + 1 === 2 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="30px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#C0C0C0"
                    >
                      <path
                        d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320ZM360-280h240v-80H440v-80h80q33 0 56.5-23.5T600-520v-80q0-33-23.5-56.5T520-680H360v80h160v80h-80q-33 0-56.5 23.5T360-440v160Z"
                        stroke="black"
                        stroke-width="10"
                      />
                    </svg>
                  ) : index + 1 === 3 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="30px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#CD7F32"
                    >
                      <path
                        d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320ZM360-280h160q33 0 56.5-23.5T600-360v-60q0-26-17-43t-43-17q26 0 43-17t17-43v-60q0-33-23.5-56.5T520-680H360v80h160v80h-80v80h80v80H360v80Z"
                        stroke="black"
                        stroke-width="10"
                      />
                    </svg>
                  ) : index + 1 === 4 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="30px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#5f6368"
                    >
                      <path
                        d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Zm40 200h80v-400h-80v160h-80v-160h-80v240h160v160Z"
                        stroke="black"
                        stroke-width="10"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="30px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#5f6368"
                    >
                      <path
                        d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320ZM360-280h160q33 0 56.5-23.5T600-360v-80q0-33-23.5-56.5T520-520h-80v-80h160v-80H360v240h160v80H360v80Z"
                        stroke="black"
                        stroke-width="10"
                      />
                    </svg>
                  )}
                </span>
              ),
            });
          }
        }
      }
      setTemperatureArea(data);
    }
  }, [selectedPattern, selectedKPI, occupancyUtilization, spaceUtilization]);

  // Effect: On map click effect
  useEffect(() => {
    if (mapClick) {
      dispatch(
        loadPerformance(
          `between=${date[0]}--${
            date[1]
          }&params=NumberOfPersons,NumberOfEmptySeats,enqueuedTime_Stamp&user=${
            userInfo?.username
          }${building ? `&building=${building.id}` : ""}&roomsSelected=true${
            floor ? `&floor=${floor.id}` : ""
          }${
            rooms !== null && rooms !== undefined && rooms.length
              ? `&rooms=${rooms.map((room) => room)}`
              : ""
          }`
        )
      );
    }
  }, [mapClick]);

  // Effect: Select/Deselect All
  useEffect(() => {
    if (floor) {
      // When all rooms are selected
      if (selectedAllRooms && selectedAllRooms === "true") {
        let areas = floor.rooms.map((room) => {
          return {
            ...room,
            left: room.leftPin,
            top: room.topPin,
            // Hover the Area function
            onMouseOver: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = `rgba(${room.color}, 0.1)`;
                e.target.style.cursor = "pointer";
              }
              setTooltipRoom(room);
              setShowDetail(true);
            },
            // Leave the Area function
            onMouseOut: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = ``;
                e.target.style.cursor = "";
              }
              setShowDetail(false);
            },
            style: {
              border: `${
                selectedAllRooms === "true"
                  ? `2px solid rgba(${room.color})`
                  : `1px solid rgba(${room.color})`
              }`,
            },
            selected: selectedAllRooms === "true" ? true : false,
          };
        });
        setMapArea(areas);

        const allRooms = floor.rooms.map((room) => room.id);
        setRooms(allRooms);

        dispatch(
          loadPerformance(
            `between=${date[0]}--${
              date[1]
            }&params=NumberOfPersons,NumberOfEmptySeats,enqueuedTime_Stamp&user=${
              userInfo?.username
            }${building ? `&building=${building.id}` : ""}${
              floor ? `&floor=${floor.id}` : ""
            }`
          )
        );
      } else if (selectedAllRooms && selectedAllRooms === "false") {
        let areas = floor.rooms.map((room) => {
          return {
            ...room,
            left: room.leftPin,
            top: room.topPin,

            // Hover the Area function
            onMouseOver: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = `rgba(${room.color}, 0.1)`;
                e.target.style.cursor = "pointer";
              }
              setTooltipRoom(room);
              console.log("test people content", noOfPeople);
              setShowDetail(true);
            },

            // Leave the Area function
            onMouseOut: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = ``;
                e.target.style.cursor = "";
              }
              setShowDetail(false);
            },
            style: {
              border: `${
                selectedAllRooms === "true"
                  ? `2px solid rgba(${room.color})`
                  : `1px solid rgba(${room.color})`
              }`,
              background: null,
            },
            selected: selectedAllRooms === "true" ? true : false,
          };
        });

        setMapArea(areas);
        setRooms([9999]);
        dispatch(
          loadPerformance(
            `between=${date[0]}--${
              date[1]
            }&params=NumberOfPersons,NumberOfEmptySeats,enqueuedTime_Stamp&user=${
              userInfo?.username
            }${building ? `&building=${building.id}` : ""}${
              floor ? `&floor=${floor.id}` : ""
            }&roomsSelected=true${
              rooms !== null && rooms !== undefined && rooms.length
                ? `&rooms=[9999]`
                : ""
            }`
          )
        );
      }
    }
  }, [selectedAllRooms]);

  return (
    <>
      {floorImage ? (
        <>
          <ImageMap
            className="usage-map"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            src={floorImage}
            map={[...temperatureArea, ...mapArea]}
            onMapClick={(area, index) => {
              // Initial load or Entry/Exit KPI or Entry Exit Activity by Date and Hour KPI is selected
              if (!selectedKPI || selectedKPI === 0 || selectedKPI === 5 || selectedKPI === 7 || selectedKPI ===20) {
                // Stationary & Robot Room Type
                if (area.roomType !== "People Count - In/Out") {
                  const modifiedAreas = [...mapArea];
                  setMapArea(modifiedAreas);
                }
                // Area previously not selected, when clicking on the area
                else if (!area.selected) {
                  // Copy map areas
                  const modifiedAreas = [...mapArea];

                  // Modify the selected area's property selected and style
                  const modifiedArea = {
                    ...area,
                    selected: true,
                    style: {
                      border: `2px solid rgba(${area.color})`,
                      zIndex: 100,
                    },
                  };

                  // Replace the selected area with the modified area
                  modifiedAreas[index - temperatureArea.length] = modifiedArea;
                  setMapArea(modifiedAreas);

                  // Get the selected room id
                  const selectedRoom =
                    modifiedAreas[index - temperatureArea.length]["id"];

                  // If room is not previously selected
                  const isRoomExist = rooms.find(
                    (room) => room.id === selectedRoom
                  );

                  // If room is not previously selected, add it to the rooms list
                  if (!isRoomExist) {
                    setRooms([...rooms, selectedRoom]);
                  }
                  setMapClick((prev) => prev + 1);
                }
                // Area previously selected, when clicking on the area
                else {
                  //Logic 2
                  const modifiedArea = {
                    ...area,
                    selected: false,
                    style: {
                      border: `1px solid rgba(${area.color})`,
                      zIndex: 100,
                    },
                  };

                  const modifiedAreas = [...mapArea];
                  modifiedAreas[index - temperatureArea.length] = modifiedArea;

                  setMapArea(modifiedAreas);
                  const unselectedRoom =
                    modifiedAreas[index - temperatureArea.length]["id"];
                  const filteredRooms = rooms.filter(
                    (room) => room !== unselectedRoom
                  );

                  console.log("test rooms list", rooms);
                  console.log("test uselected room", unselectedRoom);
                  setRooms(filteredRooms);
                  setMapClick((prev) => prev + 1);
                }
                setSelectedTime(date);
              } else {
                if (area.roomType === "People Count - In/Out") {
                  const modifiedAreas = [...mapArea];
                  setMapArea(modifiedAreas);
                }
                // Area previously not selected, when clicking on the area
                else if (!area.selected) {
                  // Copy map areas
                  const modifiedAreas = [...mapArea];

                  // Modify the selected area's property selected and style
                  const modifiedArea = {
                    ...area,
                    selected: true,
                    style: {
                      border: `2px solid rgba(${area.color})`,
                      zIndex: 100,
                    },
                  };

                  // Replace the selected area with the modified area
                  modifiedAreas[index - temperatureArea.length] = modifiedArea;
                  setMapArea(modifiedAreas);

                  // Get the selected room id
                  const selectedRoom =
                    modifiedAreas[index - temperatureArea.length]["id"];

                  // If room is not previously selected
                  const isRoomExist = rooms.find(
                    (room) => room.id === selectedRoom
                  );

                  // If room is not previously selected, add it to the rooms list
                  if (!isRoomExist) {
                    setRooms([...rooms, selectedRoom]);
                  }
                  setMapClick((prev) => prev + 1);
                }
                // Area previously selected, when clicking on the area
                else {
                  const modifiedArea = {
                    ...area,
                    selected: false,
                    style: {
                      border: `1px solid rgba(${area.color})`,
                      zIndex: 100,
                    },
                  };

                  const modifiedAreas = [...mapArea];
                  modifiedAreas[index - temperatureArea.length] = modifiedArea;

                  setMapArea(modifiedAreas);
                  const unselectedRoom =
                    modifiedAreas[index - temperatureArea.length]["id"];
                  const filteredRooms = rooms.filter(
                    (room) => room !== unselectedRoom
                  );
                  setRooms(filteredRooms);
                  setMapClick((prev) => prev + 1);
                }
                setSelectedTime(date);
              }
            }}
          />
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default PerformanceImage;
